import MarqueeLib from "react-fast-marquee";
import { useLang } from "../i18n/LanguageContext";

export default function Marquee() {
  const { t } = useLang();
  return (
    <section
      aria-hidden="true"
      data-testid="marquee"
      className="overflow-hidden border-y border-clay/70 bg-paper py-9"
    >
      <MarqueeLib gradient={false} speed={38} direction="left">
        {t.marquee.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="mx-10 font-serif text-3xl font-light italic text-umber/45 sm:text-4xl">{w}</span>
            <span className="h-1.5 w-1.5 rounded-full bg-ochre/70" />
          </span>
        ))}
      </MarqueeLib>
    </section>
  );
}
